import { enableProdMode } from '@angular/core';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

if (environment.production) {
    enableProdMode();  
}

if(!!environment.umami.length) {
    const umamiElement = window.document.createElement("script");
    umamiElement.async = true;
    umamiElement.defer = true;
    umamiElement.id = "umami-script";
    umamiElement.src = "https://umami.oxance.fr/script.js";
    umamiElement.dataset.websiteId = environment.umami;
    umamiElement.dataset.autoTrack = "false";
    document.head.appendChild(umamiElement);
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));

console.log(`%c👋 Bienvenue sur le Portail Oxance%c

Cette page a-t-elle besoin de correctifs ou d'améliorations ?
Envoyez une demande pour aider à rendre cette application plus attrayante !

%cPour envoyer une demande, rdv sur ${location.protocol}//${location.host}/demandes`,
'font-size: 2.5em;padding-top: 1em;color: #9E9E9E',
'',
'padding-bottom: 2.5em');